export const getHeaderSymbol = (labelName: string) => {
  switch (labelName) {
    case 'coupon':
    case 'vcoin':
    case 'eventVcoin':
    case 'storageVcoin':
    case 'useVcoin':
    case 'useStorageVcoin':
    case 'useEventVcoin':
    case 'useCouponValue':
      return '- ';
    case 'shippingFee':
    case 'crossBorderShippingFee':
    case 'paymentFee':
      return '+ ';
    default:
      return;
  }
};
